/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, serializePoolingFlightCreateRequest, type PoolingFlightCreateRequest, type ProblemDetails } from '../models/index.js';
// @ts-ignore
import { DeleteRequestBuilderRequestsMetadata, type DeleteRequestBuilder } from './delete/index.js';
// @ts-ignore
import { GetRequestBuilderRequestsMetadata, type GetRequestBuilder } from './get/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /PoolingFlight
 */
export interface PoolingFlightRequestBuilder extends BaseRequestBuilder<PoolingFlightRequestBuilder> {
    /**
     * The DeletePath property
     */
    get deletePath(): DeleteRequestBuilder;
    /**
     * The GetPath property
     */
    get getPath(): GetRequestBuilder;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     post(body: PoolingFlightCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: PoolingFlightCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const PoolingFlightRequestBuilderUriTemplate = "{+baseurl}/PoolingFlight";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const PoolingFlightRequestBuilderNavigationMetadata: Record<Exclude<keyof PoolingFlightRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    deletePath: {
        requestsMetadata: DeleteRequestBuilderRequestsMetadata,
    },
    getPath: {
        requestsMetadata: GetRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const PoolingFlightRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: PoolingFlightRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializePoolingFlightCreateRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
